exports.connect = {
	url: "https://api.campinglescharmes.camp/"
}
